export default "__VITE_ASSET__mpdA$22___"